@if (isLink) {
<li class="rs-padding-top3-so"><!-- //NOSONAR -->
  <a href="javascript:void(0)" (click)="onDownloadPdf(docType)" data-tms-event="button-click"
    [attr.data-tms-button-zone]="buttonZone" [attr.data-tms-button-name]="tmsButtonName"
    [attr.aria-disabled]="isDownloadInProgress" [attr.data-tms-context]="documentId"
    [attr.data-tms-message-info]="paId">{{ linkLabel
    }}<span class="rs-link-download-info">{{ linkSubLabel }}</span></a>
</li>
} @else {
<button class="rs-link-action rs-link-action-download" *ngIf="!isDownloadInProgress" (click)="onDownloadPdf(docType)"
  data-tms-event="button-click" [attr.data-tms-button-zone]="buttonZone" [attr.data-tms-button-name]="tmsButtonName"
  [attr.data-tms-context]="documentId" [attr.data-tms-message-info]="paId">
  <span class="rs-link-action-label" aria-hidden="true">{{ linkLabel }} </span>
  <span class="rs-action-link-icon" [title]="linkLabel">
    <span class="show-for-sr">{{ linkLabel }}</span></span>
</button>
<button class="rs-link-action rs-link-action-download" *ngIf="isDownloadInProgress" disabled
  data-tms-event="button-click" [attr.data-tms-button-zone]="buttonZone" [attr.data-tms-button-name]="tmsButtonName"
  [attr.data-tms-context]="documentId" [attr.data-tms-message-info]="paId">
  <span class="rs-link-action-label" aria-hidden="true">{{ linkLabel }} </span>
  <span class="rs-action-link-icon" [title]="linkLabel">
    <span class="show-for-sr">{{ linkLabel }}</span></span>
</button>
<lib-generic-message-box [messageType]="messageBoxTypeError" id="messageBoxTypeError" [showCross]="false"
  [cypressTag]="messageBoxTypeError" *ngIf="hasError">
  <ng-container Title>{{ messageBoxTitle }}</ng-container>
  <p Content [innerHtml]="messageBoxContent"></p>
</lib-generic-message-box>
}